import React from 'react';
import './List.css';
import '../App.css';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Lottie from 'lottie-react';
import errorAnimation from '../assets/error-404.json';

export const NotFoundPage: React.FC = () => {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      main: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: window.innerHeight
      }
    })
  );

  const classes = useStyles();

  return (
    <div className={classes.main}>
      <Lottie
        loop={true}
        autoplay={true}
        animationData={errorAnimation}
        rendererSettings={{
          preserveAspectRatio: 'xMidYMid slice'
        }}
        width={200}
      />
    </div>
  );
};
